import React from 'react'

import { Icon } from '@mxenabled/mx-icons'
import { Text } from '@mxenabled/mxui'

import { type SxProps, type Theme } from '@mui/material/styles'

interface DirectDepositSubHeaderProps {
  boldText?: boolean
  iconColor?:
    | 'inherit'
    | 'action'
    | 'disabled'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
  iconFill?: boolean
  iconSX?: SxProps<Theme>
  name?: string
  size?: number
  subHeaderString: string
  textSX?: SxProps<Theme>
}

export const DirectDepositSubHeader: React.FC<DirectDepositSubHeaderProps> = ({
  boldText,
  iconColor,
  iconFill,
  iconSX,
  name,
  size,
  subHeaderString,
  textSX,
}) => {
  return (
    <>
      {name && <Icon color={iconColor} fill={iconFill} name={name} size={size} sx={iconSX} />}
      <Text bold={boldText} sx={textSX}>
        {subHeaderString}
      </Text>
    </>
  )
}
